let lockCount = 0;

const canUseDom = () => typeof document !== 'undefined' && document.body;

export function lockBodyScroll() {
  if (!canUseDom()) return;

  lockCount += 1;
  if (lockCount === 1) {
    document.body.style.overflow = 'hidden';
  }
}

export function unlockBodyScroll() {
  if (!canUseDom()) return;

  lockCount = Math.max(0, lockCount - 1);
  if (lockCount === 0) {
    document.body.style.overflow = '';
  }
}
